'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    // NOTE: Use this only to display the weekly, never to use the weekly for calculations
    adjustAvailability: function adjustAvailability(availability, dow) {

        if (!availability) {
            return availability;
        }

        if (_lodash2.default.get(availability, 'weekly[0].minuteOfWeek') === 0 && _lodash2.default.get(availability, 'weekly[0].durationMins') === 10080) return availability;

        var rc = JSON.parse((0, _stringify2.default)(availability));

        unwrapWeek(rc);

        rc.weekly = _lodash2.default.map(rc.weekly, function (obj) {
            var newMOW = obj.minuteOfWeek - 1440 * dow;
            if (newMOW < 0) {
                newMOW += 7 * 1440;
            }

            return { minuteOfWeek: newMOW, durationMins: obj.durationMins };
        });

        wrapWeek(rc);

        rc.weekly = _lodash2.default.sortBy(rc.weekly, 'minuteOfWeek');

        // TODO: adjust exceptions? Not sure needed
        return rc;
    },

    // NOTE: Use this only to display the weekly, never to use the weekly for calculations
    adjustDayStrings: function adjustDayStrings(firstDay, i18n) {
        var dayStrings = [i18n.get('openrest_days_sunday_short', 'Sun'), i18n.get('openrest_days_monday_short', 'Mon'), i18n.get('openrest_days_tuesday_short', 'Tue'), i18n.get('openrest_days_wednesday_short', 'Wed'), i18n.get('openrest_days_thursday_short', 'Thu'), i18n.get('openrest_days_friday_short', 'Fri'), i18n.get('openrest_days_saturday_short', 'Sat')];

        return _lodash2.default.slice(dayStrings, firstDay).concat(dayStrings.slice(0, firstDay));
    }

};


var unwrapWeek = function unwrapWeek(availability) {
    var timespanFrom0 = _lodash2.default.find(availability.weekly, function (timespan) {
        return timespan.minuteOfWeek === 0;
    });

    if (!timespanFrom0) return;

    var timespanTo10080 = _lodash2.default.find(availability.weekly, function (timespan) {
        return timespan.minuteOfWeek + timespan.durationMins === 10080;
    });

    if (!timespanTo10080) return;

    availability.weekly = _lodash2.default.reject(availability.weekly, function (timespan) {
        if (timespan.minuteOfWeek === 0) return true;
        if (timespan.minuteOfWeek + timespan.durationMins === 10080) return true;
        return false;
    });

    availability.weekly.push({ minuteOfWeek: timespanTo10080.minuteOfWeek, durationMins: timespanFrom0.durationMins + timespanTo10080.durationMins });
};

var wrapWeek = function wrapWeek(availability) {
    var reminderDurations = 0;

    availability.weekly = _lodash2.default.map(availability.weekly, function (obj) {
        if (obj.minuteOfWeek + obj.durationMins > 10080) {
            reminderDurations = obj.minuteOfWeek + obj.durationMins - 10080;
            obj.durationMins = 10080 - obj.minuteOfWeek;
        }

        return { minuteOfWeek: obj.minuteOfWeek, durationMins: obj.durationMins };
    });

    if (reminderDurations) {
        availability.weekly.push({ minuteOfWeek: 0, durationMins: reminderDurations });
    }
};